/**
 * Old Wix path → new homepage anchor or dedicated page.
 * Used by <RedirectFromOldWix> to issue a client-side redirect with
 * proper history.replaceState (so Google treats it as a permanent move
 * once paired with edge-level 301s configured at the host).
 *
 * The matching is case-insensitive and ignores any trailing slash.
 */
export const WIX_REDIRECTS = {
  // ── Old Wix paths → dedicated service pages ───────────────────────────
  "/studio": "/studio-hire",
  "/studio-1": "/studio-hire",
  "/studiohire": "/studio-hire",
  "/photography": "/photography-video",
  "/photography-1": "/photography-video",
  "/video": "/photography-video",
  "/videography": "/photography-video",
  "/headshot": "/headshots",
  "/headshot-1": "/headshots",
  "/equipment-1": "/equipment",
  "/retouching-1": "/retouching",

  // ── Old Wix paths → "about" homepage section (#about) ─────────────────
  "/about": "/#about",
  "/about-us": "/#about",
  "/about-1": "/#about",
  "/aboutus": "/#about",
  "/our-team": "/#about",
  "/team": "/#about",
  "/our-story": "/#about",
  "/story": "/#about",

  // ── Old Wix paths → "services" homepage section (#services) ───────────
  "/services": "/#services",
  "/our-services": "/#services",
  "/our-service": "/#services",
  "/services-1": "/#services",
  "/what-we-do": "/#services",
  "/propsandfurniture": "/props-and-furniture",
  "/props": "/props-and-furniture",
  "/props-and-furniture-1": "/props-and-furniture",

  // ── Old Wix paths → "gallery" homepage section (#gallery) ─────────────
  "/gallery-1": "/#gallery",
  "/portfolio": "/#gallery",
  "/work": "/#gallery",
  "/our-work": "/#gallery",
  "/showcase": "/#gallery",

  // ── Old Wix paths → "contact" homepage section (#contact) ─────────────
  // Per user request, send all booking/contact URLs to the bottom #contact
  // section rather than the dedicated /book page.
  "/contact": "/#contact",
  "/contact-us": "/#contact",
  "/contact-1": "/#contact",
  "/contactus": "/#contact",
  "/get-in-touch": "/#contact",
  "/getintouch": "/#contact",
  "/booking": "/#contact",
  "/book-online": "/#contact",
  "/bookings": "/#contact",
  "/book-now": "/#contact",
  "/book-contact": "/#contact",
  "/book-1": "/#contact",
  "/enquire": "/#contact",
  "/enquiries": "/#contact",

  // ── Misc Wix conventions → homepage ───────────────────────────────────
  "/home": "/",
  "/home-1": "/",
  "/index": "/",
};
